import { render, staticRenderFns } from "./v20a5000pc.vue?vue&type=template&id=776f72e2&scoped=true&"
import script from "./v20a5000pc.vue?vue&type=script&lang=js&"
export * from "./v20a5000pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776f72e2",
  null
  
)

export default component.exports